import React, { useState } from 'react';
import { useAuth } from '../contexts/SimpleAuthContext';

const ClearCache = () => {
  const { clearAllAuthData } = useAuth();
  const [cleared, setCleared] = useState(false);

  const handleClearCache = () => {
    clearAllAuthData();
    setCleared(true);
    
    // Redirect to home after 3 seconds
    setTimeout(() => {
      window.location.href = '/';
    }, 3000);
  };

  if (cleared) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5'
      }}>
        <div style={{
          textAlign: 'center',
          padding: '2rem',
          backgroundColor: 'white',
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          maxWidth: '500px'
        }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✅</div>
          <h2 style={{ color: '#1a1a1a', marginBottom: '1rem' }}>
            Cache Cleared Successfully!
          </h2>
          <p style={{ color: '#666', marginBottom: '2rem' }}>
            All authentication data has been cleared. 
            Redirecting to home page...
          </p>
          <div style={{
            backgroundColor: '#d4edda',
            border: '1px solid #c3e6cb',
            color: '#155724',
            padding: '1rem',
            borderRadius: '6px',
            fontSize: '0.9rem'
          }}>
            <strong>What was cleared:</strong>
            <br />
            • Authentication tokens
            <br />
            • Local storage data
            <br />
            • Session storage
            <br />
            • Browser cookies
            <br />
            • Cached user data
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f5f5f5'
    }}>
      <div style={{
        textAlign: 'center',
        padding: '2rem',
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        maxWidth: '500px'
      }}>
        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🧹</div>
        <h2 style={{ color: '#1a1a1a', marginBottom: '1rem' }}>
          Clear Authentication Cache
        </h2>
        <p style={{ color: '#666', marginBottom: '2rem' }}>
          If you're experiencing login loops or authentication issues, 
          clearing the cache can help resolve these problems.
        </p>
        
        <div style={{
          backgroundColor: '#fff3cd',
          border: '1px solid #ffeaa7',
          color: '#856404',
          padding: '1rem',
          borderRadius: '6px',
          marginBottom: '2rem',
          fontSize: '0.9rem'
        }}>
          <strong>This will clear:</strong>
          <br />
          • All stored authentication tokens
          <br />
          • Local storage and session data
          <br />
          • Browser cookies for this site
          <br />
          • Any cached user information
        </div>

        <div style={{
          display: 'flex',
          gap: '1rem',
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}>
          <button
            onClick={handleClearCache}
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: '#dc3545',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            🧹 Clear Cache Now
          </button>

          <a
            href="/"
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: '#6c757d',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '6px',
              fontWeight: '600'
            }}
          >
            Cancel
          </a>
        </div>

        <div style={{
          marginTop: '2rem',
          padding: '1rem',
          backgroundColor: '#e7f3ff',
          border: '1px solid #b3d9ff',
          borderRadius: '6px',
          fontSize: '0.85rem',
          color: '#0c5460'
        }}>
          <strong>💡 Tip:</strong> You can also manually clear your browser cache by:
          <br />
          1. Opening Developer Tools (F12)
          <br />
          2. Going to Application/Storage tab
          <br />
          3. Clearing Local Storage, Session Storage, and Cookies
        </div>
      </div>
    </div>
  );
};

export default ClearCache;
